import { type IconProps } from '_/ui/icons/icon.types'
import IconUse from '_/ui/icons/use'
import { tv } from 'tailwind-variants'

export const styles = tv({
	base: 'absolute right-6 text-primary-neutral fill-transparent top-1/2 -translate-y-1/2',
})

export const CheckIcon = ({ className, ...rest }: IconProps) => (
	<IconUse id='check' width={17} height={12} className={styles({ class: className })} {...rest} />
)
